import { RelationshipType } from '@/types/childContactRelationship';
import { formatDateMedium } from '@/lib/format';
import { Shield, User } from 'lucide-react';
import type { I18n } from '@lingui/core';
import { msg } from '@lingui/macro';

export const getRelationshipTypeIcon = (type: RelationshipType) => {
  switch (type) {
    case RelationshipType.PARENT:
    case RelationshipType.GUARDIAN:
    case RelationshipType.FOSTER_PARENT:
      return Shield;
    case RelationshipType.GRANDPARENT:
    case RelationshipType.AUNT_UNCLE:
    case RelationshipType.SIBLING:
      return User;
    default:
      return User;
  }
};

export const getRelationshipTypeLabel = (type: RelationshipType, i18n: I18n): string => {
  switch (type) {
    case RelationshipType.PARENT:
      return i18n._(msg`Parent`);
    case RelationshipType.GUARDIAN:
      return i18n._(msg`Guardian`);
    case RelationshipType.GRANDPARENT:
      return i18n._(msg`Grandparent`);
    case RelationshipType.SIBLING:
      return i18n._(msg`Sibling`);
    case RelationshipType.AUNT_UNCLE:
      return i18n._(msg`Aunt/Uncle`);
    case RelationshipType.STEP_PARENT:
      return i18n._(msg`Step Parent`);
    case RelationshipType.FOSTER_PARENT:
      return i18n._(msg`Foster Parent`);
    case RelationshipType.FAMILY_FRIEND:
      return i18n._(msg`Family Friend`);
    case RelationshipType.NANNY:
      return i18n._(msg`Nanny`);
    // RelationshipTypeSelector offers all 17 enum values, so these are
    // assignable and were rendering as "Other" — a registered pediatrician or
    // neighbour lost its identity on the contact card. Same source strings as
    // the selector, so the existing translations apply.
    case RelationshipType.GREAT_AUNT_UNCLE:
      return i18n._(msg`Great Aunt/Uncle`);
    case RelationshipType.COUSIN:
      return i18n._(msg`Cousin`);
    case RelationshipType.GODMOTHER_GODFATHER:
      return i18n._(msg`Godmother/Godfather`);
    case RelationshipType.NEIGHBOR:
      return i18n._(msg`Neighbor`);
    case RelationshipType.AUPAIR:
      return i18n._(msg`Au Pair`);
    case RelationshipType.BABYSITTER:
      return i18n._(msg`Babysitter`);
    case RelationshipType.PEDIATRICIAN:
      return i18n._(msg`Pediatrician`);
    case RelationshipType.OTHER:
      return i18n._(msg`Other`);
    default:
      return i18n._(msg`Other`);
  }
};

export const formatValidityDate = (date: string, locale: string): string =>
  formatDateMedium(date, locale);